var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Tambah ICD X Details")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("h4", { staticClass: "mb-3" }, [_vm._v("Data ICD X Tambah")]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header text-white bg-primary" }, [
            _vm._v("Tambah ICD X"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm._l(_vm.update_icdx, function (icdx, idx) {
                return [
                  _vm.input_labels[idx]
                    ? _c("div", { key: idx, staticClass: "row mb-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-4 col-form-label text-end",
                            attrs: { for: idx },
                          },
                          [_vm._v(_vm._s(_vm.input_labels[idx]))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6" }, [
                          !_vm.inArray(idx, _vm.input_filtered)
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.update_icdx[idx],
                                    expression: "update_icdx[idx]",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { name: idx, type: "text", id: idx },
                                domProps: { value: _vm.update_icdx[idx] },
                                on: {
                                  change: function ($event) {
                                    return _vm.validate(idx)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.update_icdx,
                                      idx,
                                      $event.target.value
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col text-end" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success",
                      on: { click: _vm.saveICDX },
                    },
                    [_vm._v("Save")]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }